import { render, staticRenderFns } from "./xietong.vue?vue&type=template&id=b7993634&scoped=true"
import script from "./xietong.vue?vue&type=script&lang=js"
export * from "./xietong.vue?vue&type=script&lang=js"
import style0 from "./xietong.vue?vue&type=style&index=0&id=b7993634&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7993634",
  null
  
)

export default component.exports